/*@flow*/
import isType from 'lib/t/isType';
import getTypeName from 'lib/t/getTypeName';
import stringify from 'lib/t/stringify';
import assert from 'lib/t/assert';
import maybe from 'lib/t/maybe';
import subtype from 'lib/t/refinement';
import containsUnion from './containsUnion';

function getUnionConcreteType(type: any, value: any) {
  const kind = type.meta.kind;
  if (kind === 'union') {
    const concreteType = type.dispatch(value);
    if (process.env.NODE_ENV !== 'production') {
      assert(
        isType(concreteType),
        () =>
          'Invalid value ' +
          stringify(value) +
          ' supplied to ' +
          getTypeName(type) +
          ' (no constructor returned by dispatch)'
      );
    }
    return concreteType;
  } else if (kind === 'maybe') {
    const maybeConcrete = maybe(
      getUnionConcreteType(type.meta.type, value),
      type.meta.name
    );
    maybeConcrete.getValidationErrorMessage = type.getValidationErrorMessage;
    maybeConcrete.getTcombFormFactory = type.getTcombFormFactory;
    return maybeConcrete;
  } else if (kind === 'subtype') {
    const subtypeConcrete = subtype(
      getUnionConcreteType(type.meta.type, value),
      type.meta.predicate,
      type.meta.name
    );
    subtypeConcrete.getValidationErrorMessage = type.getValidationErrorMessage;
    subtypeConcrete.getTcombFormFactory = type.getTcombFormFactory;
    return subtypeConcrete;
  }
  return type;
}

export default function getTypeFromUnion(type: any, value: any) {
  if (containsUnion(type)) {
    return getUnionConcreteType(type, value);
  }
  return type;
}
